var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import View from '../../../elements/View';
import ToggleSelect from '../../../elements/ToggleSelect';
import cloneDeep from 'lodash/cloneDeep';
import { EditorLanguage } from '../../../components/EditorLanguage';
import { Button as RButton, ButtonGroup, ButtonToolbar, Col, Container, Row } from 'reactstrap';
import { T } from '../../../helpers/i18n';
import theme from '../../../Theme';
import { StretchImages } from '../../../components/StretchImages';
import { TabPoints } from '../../../components/LocationPicker/container/TabPoints';
import { inject } from 'mobx-react';
export var Languages;
(function (Languages) {
    Languages["es"] = "es";
    Languages["en"] = "en";
    Languages["fr"] = "fr";
    Languages["de"] = "de";
    Languages["he"] = "he";
    Languages["nl"] = "nl";
})(Languages || (Languages = {}));
var DataWeb = /** @class */ (function (_super) {
    __extends(DataWeb, _super);
    function DataWeb(props) {
        var _this = _super.call(this, props) || this;
        _this.languageSelected = function () {
            return _this.state.languageSelected[0];
        };
        _this.state = {
            languageSelected: [DataWeb_1.defaultLanguage],
            value: cloneDeep(props.dataweb || {}),
            viewSelected: ViewSelected.infoDataweb
        };
        return _this;
    }
    DataWeb_1 = DataWeb;
    DataWeb.prototype.render = function () {
        // console.log('DataWeb- render - dataWeb: ', this.props.dataweb)
        var _this = this;
        var images = [];
        var dataweb = this.props.dataweb || {}; // por si no tiene aún datos
        for (var key in dataweb) {
            if (key.includes('image') /*&& dataweb[key]*/) {
                images.push({
                    name: key,
                    url: dataweb[key]
                });
            }
        }
        var _images = images.sort(function (a, b) {
            var subA = a.name.slice(5);
            var subB = b.name.slice(5);
            return Number(subA) - Number(subB);
        });
        return (React.createElement(View, { style: { width: '100%' } },
            React.createElement(Container, null,
                React.createElement(Row, null,
                    React.createElement(Col, null,
                        React.createElement(ButtonToolbar, null,
                            React.createElement(ButtonGroup, null,
                                React.createElement(RButton, { outline: true, style: {
                                        color: this.state.viewSelected === ViewSelected.infoDataweb
                                            ? theme.color.primary
                                            : theme.color.secondary
                                    }, onClick: function () { return _this.setState({ viewSelected: ViewSelected.infoDataweb }); } }, T('infoDataweb')),
                                React.createElement(RButton, { outline: true, style: {
                                        color: this.state.viewSelected === ViewSelected.termsDataweb
                                            ? theme.color.primary
                                            : theme.color.secondary
                                    }, onClick: function () { return _this.setState({ viewSelected: ViewSelected.termsDataweb }); } }, T('termsDataweb')),
                                React.createElement(RButton, { outline: true, style: {
                                        color: this.state.viewSelected === ViewSelected.imagesDataweb
                                            ? theme.color.primary
                                            : theme.color.secondary
                                    }, onClick: function () { return _this.setState({ viewSelected: ViewSelected.imagesDataweb }); } }, T('imagesDataweb')),
                                React.createElement(RButton, { outline: true, style: {
                                        color: this.state.viewSelected === ViewSelected.tags
                                            ? theme.color.primary
                                            : theme.color.secondary
                                    }, onClick: function () { return _this.setState({ viewSelected: ViewSelected.tags }); } }, T('tags')),
                                React.createElement(RButton, { outline: true, style: {
                                        color: this.state.viewSelected === ViewSelected.points
                                            ? theme.color.primary
                                            : theme.color.secondary
                                    }, onClick: function () { return _this.setState({ viewSelected: ViewSelected.points }); } }, T('points'))))))),
            React.createElement("br", null),
            this.state.viewSelected === ViewSelected.points &&
                React.createElement(TabPoints, { locationsPoints: (dataweb === null || dataweb === void 0 ? void 0 : dataweb.locationsPoints) || [], onChangeLocationPoints: function (points) {
                        console.log('onChangeLocationPoints', points);
                        _this.props.onChange({
                            value: points,
                            field: 'locationsPoints',
                            lang: null
                        });
                    } }),
            (this.state.viewSelected === ViewSelected.infoDataweb ||
                this.state.viewSelected === ViewSelected.termsDataweb ||
                this.state.viewSelected === ViewSelected.tags) &&
                React.createElement(View, null,
                    (this.state.viewSelected === ViewSelected.infoDataweb ||
                        this.state.viewSelected === ViewSelected.termsDataweb) && React.createElement(View, null,
                        React.createElement(ToggleSelect, { styleItem: {
                                paddingLeft: '20px',
                                paddingRight: '20px'
                            }, multiple: false, value: this.state.languageSelected, options: Object.entries(Languages).map(function (language) {
                                return { id: language[1], name: language[0], value: language[1], selected: !!_this.state.languageSelected.find(function (item) { return item === language[1]; }) };
                            }), onChange: function (value) {
                                var selected = [];
                                value.target.options.forEach(function (option) {
                                    if (option.selected) {
                                        selected.push(option.value);
                                    }
                                });
                                _this.setState({ languageSelected: selected });
                            } })),
                    React.createElement(EditorLanguage, { dataweb: dataweb, destinations: this.props.destinations, categories: this.props.categories, tags: this.props.tags, viewSelected: this.state.viewSelected, languageSelected: this.languageSelected(), editorStateCopied: this.state.editorStateCopied, editorStateTermCopied: this.state.editorStateTermCopied, onEditorStateCopied: function () {
                        }, onChange: function (_a) {
                            var value = _a.value, field = _a.field, lang = _a.lang;
                            if (!_this.props.onChange)
                                return;
                            _this.props.onChange({
                                value: value,
                                field: field,
                                lang: lang
                            });
                        } })),
            this.state.viewSelected === ViewSelected.imagesDataweb && this.props.stretch_id &&
                React.createElement(StretchImages, { images: _images, stretch_id: this.props.stretch_id, onDragged: function (newList) {
                        // cambio el orden
                        var max = newList.length;
                        var temp = {};
                        for (var i = 0; i < max; i++) {
                            temp["image".concat(i + 1)] = newList[i].url;
                        }
                        _this.props.onChangeOrder(temp);
                    } })));
    };
    var DataWeb_1;
    // @ts-ignore
    DataWeb.defaultLanguage = Languages.es;
    DataWeb = DataWeb_1 = __decorate([
        inject('store')
    ], DataWeb);
    return DataWeb;
}(Component));
export { DataWeb };
export var Fields = {
    custom: 'custom',
    terminosCondiciones: 'terminosCondiciones',
    placeholder: 'placeholder',
    tags: 'tags'
};
export var ViewSelected = {
    infoDataweb: 'infoDataweb',
    imagesDataweb: 'imagesDataweb',
    termsDataweb: 'termsDataweb',
    tags: 'tags',
    points: 'points',
};
export var MAX_IMAGES = 15;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/container/DataWeb.tsx
// module id = 542
// module chunks = 0